import { FunctionComponent, useEffect } from 'react'

import styled, { css } from 'styled-components'

import config from '@config'
import { desktopCSS, mobileCSS } from '@measures/responsive'
import translate from '@i18n'
import useBlickPlusOnboardingTracking from '@hooks/useBlickPlusOnboardingTracking'
import useViewportTracking from '@hooks/useViewportTracking'
import Text from '@components/BlickPlusOnboardingModal/Text'
import Title from '@components/BlickPlusOnboardingModal/Title'

const {
  blickPlusOnboarding: { targetElementId, recommendationWidgetId },
} = config

const StyledWrapper = styled.div`
  ${({
    theme: {
      spacing: { spacing24 },
    },
  }) => css`
    display: flex;
    flex-direction: column;
    gap: ${spacing24};
  `}
`

const StyledHeadline = styled.div`
  ${({
    theme: {
      spacing: { spacing12 },
    },
  }) => css`
    display: flex;
    flex-direction: column;
    gap: 10px;
    ${desktopCSS(css`
      gap: ${spacing12};
    `)}
  `}
`

const StyledHighlights = styled.div`
  ${({
    theme: {
      colors: { textDefault, textWeak },
      spacing: { spacing8, spacing16 },
      utils: { ellipsis },
    },
  }) => css`
    margin-top: ${spacing16};
    ${desktopCSS(css`
      margin-top: ${spacing8};
    `)}

    .catchword {
      color: ${textWeak};
    }

    .cx-flex-module-container {
      margin: 0;
    }

    .text-wrapper {
      ${mobileCSS(css`
        width: calc(100% - 134px - 15px);
      `)}
      width: calc(100% - 140px - 15px);

      h3 {
        color: ${textDefault}!important;
        ${ellipsis('100%', 4)};
      }
    }

    .cx-flex-module {
      gap: ${spacing8}!important;
      margin: 0 !important;
      ${desktopCSS(css`
        gap: ${spacing16}!important;
      `)}
    }
  `}
`

const HighlightsPage: FunctionComponent = () => {
  const { trackOnImpression } = useBlickPlusOnboardingTracking()

  const viewportRef = useViewportTracking({
    onImpression: trackOnImpression,
    track: true,
  })

  useEffect(() => {
    if (window?.cX?.CCE) {
      window.cX.CCE.run({
        widgetId: recommendationWidgetId,
        targetElementId: targetElementId,
      })
    }
  }, [])

  return (
    <StyledWrapper ref={viewportRef}>
      <StyledHeadline>
        <Title>
          {translate('blickPlusOnboardingModal.highlightsPage.title')}
        </Title>
        <Text>{translate('blickPlusOnboardingModal.highlightsPage.text')}</Text>
      </StyledHeadline>
      <StyledHighlights id={targetElementId} />
    </StyledWrapper>
  )
}

export default HighlightsPage
